import { IUserPermissions } from 'types/User';

/**
 * Check if user has admin-manager role
 * @param permissions - User permissions array
 * @returns boolean indicating if user is admin-manager
 */
export const isAdminManager = (permissions?: IUserPermissions[]): boolean => {
	if (!permissions || permissions.length === 0) {
		return false;
	}

	return permissions.some((permission) => permission.role === 'admin-manager');
};

/**
 * Check if user has access to ICAM functionality
 * Only admin-managers should have access to ICAM
 * @param permissions - User permissions array
 * @param branchId - Optional branch ID to check for specific branch access
 * @returns boolean indicating if user has ICAM access
 */
export const hasICAMAccess = (
	permissions?: IUserPermissions[],
	branchId?: string | null
): boolean => {
	if (!permissions || permissions.length === 0) {
		return false;
	}

	// If no branchId is provided, check if user is admin-manager for any branch
	if (!branchId) {
		return isAdminManager(permissions);
	}

	// Check if user has admin-manager role for the specific branch
	return permissions.some(
		(permission) =>
			permission.role === 'admin-manager' &&
			permission.branch?.id?.toString() === branchId.toString()
	);
};

/**
 * Check if user has any manager role (manager or admin-manager)
 * @param permissions - User permissions array
 * @returns boolean indicating if user is any type of manager
 */
export const isManager = (permissions?: IUserPermissions[]): boolean => {
	if (!permissions || permissions.length === 0) {
		return false;
	}

	return permissions.some(
		(permission) =>
			permission.role === 'manager' || permission.role === 'admin-manager'
	);
};
